import config from "config/appConfig";

import type { IStateProps } from "utils/StateOf";
import createStoreFunction from "utils/createStore";

import type { BetsModel, LastGamesActionModel, SportBetsModel } from "../../types/BetsModel";

const localStorageKey = `${config.GLOBAL_CONSTANTS.LOCAL_STORAGE_PREFIX}${config.HOOK_STORAGE_KEYS.BETS_DATA}`;

export interface Values {
	loading: boolean;

	bets: BetsModel[];
	sportBets: SportBetsModel[];

	loadingLastGamesActions: boolean;
	lastGamesActions: LastGamesActionModel[];
}

export const initialState: IStateProps<Values> = {
	loading: false,

	bets: [],
	sportBets: [],

	loadingLastGamesActions: false,
	lastGamesActions: []
};

export default createStoreFunction<Values>({
	initialState,
	persistant: true,
	persistantName: localStorageKey
});
